import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { User } from "lucide-react";

function toneClass(dept, isHead) {
  if (isHead) return "bg-[#FFC72C] text-[#083B1E] border-[#FFC72C]";
  const d = dept || "";
  if (d.indexOf("Pilot") >= 0) return "bg-white text-slate-800 border-[#00A651]/40";
  if (d.indexOf("FA") >= 0) return "bg-white text-slate-800 border-violet-400/50";
  if (d.indexOf("Support") >= 0 || d.indexOf("Admin") >= 0) return "bg-slate-50 text-slate-700 border-slate-300";
  return "bg-white text-slate-800 border-slate-300";
}

function OrgNode(props) {
  const n = props.node;
  const isHead = !!props.isHead;
  const cls = "rounded-xl px-3 py-2 text-center shadow-sm border min-w-[170px] " + toneClass(n.department, isHead);
  return (
    <div className={cls} data-testid={"org-node-" + n.id}>
      <div className={"text-[10px] uppercase tracking-widest font-semibold " + (isHead ? "text-[#083B1E]/80" : "text-[#00A651]")}>{n.department || "Position"}</div>
      <div className="font-bold text-sm mt-0.5 text-slate-900" style={{ fontFamily: "Outfit" }}>{n.position_name}</div>
      {n.pic ? <div className="text-[10px] text-slate-600 mt-1 flex items-center justify-center gap-1"><User className="w-2.5 h-2.5" />{n.pic}</div> : null}
    </div>
  );
}

function renderBranch(node, byParent, depth) {
  const kids = (byParent[node.id] || []).slice().sort(function (a, b) { return (a.display_order || 0) - (b.display_order || 0); });
  return (
    <div key={node.id} className="flex flex-col items-center">
      <OrgNode node={node} isHead={depth === 0} />
      {kids.length > 0 ? (
        <div className="flex flex-col items-center w-full">
          <div className="w-px h-4 bg-slate-300" />
          <div className="flex flex-wrap gap-4 justify-center pt-3 relative">
            {kids.length > 1 ? <div className="absolute top-0 left-6 right-6 h-px bg-slate-300" /> : null}
            {kids.map(function (k) {
              return (
                <div key={k.id} className="flex flex-col items-center relative">
                  <div className="w-px h-3 bg-slate-300 -mt-3" />
                  {renderBranch(k, byParent, depth + 1)}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default function OrgChart() {
  const q = useQuery({
    queryKey: ["organization"],
    queryFn: async function () { return (await apiClient.get("/organization/active")).data; },
  });
  if (q.isLoading) return <Skeleton className="h-64 w-full rounded-xl" />;
  const list = q.data || [];
  const byParent = {};
  list.forEach(function (n) { const k = n.parent_id || "ROOT"; if (!byParent[k]) byParent[k] = []; byParent[k].push(n); });
  const roots = byParent["ROOT"] || [];
  if (roots.length === 0) return <div className="text-sm italic text-slate-500 py-8 text-center">Struktur organisasi belum diisi.</div>;
  return (
    <div className="w-full overflow-x-auto pb-4" data-testid="org-chart">
      <div className="min-w-max mx-auto">
        {roots.map(function (r) { return renderBranch(r, byParent, 0); })}
      </div>
    </div>
  );
}
